import classNames from 'classnames'
import {memo, useEffect, useMemo, useRef} from 'react'

import {useAppSelector} from '../../../../../hooks/react-redux'
import {useBooleanQueryParam} from '../../../../../hooks/routes'
import {useIsStuck} from '../../../../../hooks/useIsStuck'
import {useBanners} from '../../contexts/Banners/BannersContext'
import {MessageType, RELOAD_MESSAGE} from '../../contexts/Banners/BannersContext.types'
import {usePipelineId} from '../../hooks/pipeline'
import Banners from '../../PipelineRunPage/PipelineTab/Banners/Banners'
import {isStoreYamlInVcsEnabled} from '../../utils/featureToggles'

import EditPipelineToggle from './EditPipelineToggle/EditPipelineToggle'
import EditPipelineYamlActions from './EditPipelineYamlActions/EditPipelineYamlActions'
import EditPipelineYamlCounters from './EditPipelineYamlCounters/EditPipelineYamlCounters'

import styles from './EditPipelineToolbar.css'

type Props = {
  className?: string
}

function EditPipelineToolbar({className}: Props) {
  const id = usePipelineId()
  const isYaml = useBooleanQueryParam('yaml')

  const ref = useRef<HTMLDivElement>(null)
  const isStuck = useIsStuck(ref)
  const isCollisionApi = useAppSelector(state => state.pipelines.pipelineDraft[id]?.isCollisionApi)
  const {addBanner} = useBanners()

  const reloadActions = useMemo(
    () => [{label: 'Reload', onClick: () => window.location.reload()}],
    [],
  )
  useEffect(() => {
    if (isStoreYamlInVcsEnabled && isCollisionApi) {
      addBanner(id, {
        key: `${id}-${RELOAD_MESSAGE}`,
        message: 'This Pipeline was modified, reload the page to view updated settings',
        type: MessageType.WARNING,
        actions: reloadActions,
      })
    }
  }, [addBanner, id, isCollisionApi, reloadActions])

  return (
    <>
      {isStoreYamlInVcsEnabled && <Banners />}
      <div className={styles.psevdoPanel} ref={ref} />
      <div className={classNames(className, styles.panel, {[styles.stuck]: isStuck})}>
        <EditPipelineToggle />
        {isYaml && <EditPipelineYamlActions />}
        {isYaml && <EditPipelineYamlCounters />}
      </div>
    </>
  )
}

export default memo(EditPipelineToolbar)
